import _ from 'lodash';

import * as constants from './NoteDetail.constants';
import * as services from './NoteDetail.service';

const state = {
  noteDetail: {
    books: [
      {
        readings: [
          {
            bullets: [{}],
          },
        ],
      },
    ],
  },

  readingIdx: 0,
  bulletIdx: 0,
  noteIdx: 0,

  //downloadAddress: '',
  isRequest: false,
};

const mutations = {
  [constants.GET_NOTE_DETAIL_SUCCESS](state, noteDetail) {
    if (undefined !== noteDetail && null !== noteDetail) {
      state.noteDetail = noteDetail;
    }
  },

  [constants.UPDATE_NOTE_DETAIL_SUCCESS](state, payload) {
    const { note, objUpd } = payload;
    state.noteDetail = {
      ...state.noteDetail,
      books: _.map(state.noteDetail.books, (book) => ({
        ...book,
        readings: _.map(book.readings, (reading) => {
          if (note.readingId === reading.readingId) {
            return {
              ...reading,
              bullets: _.map(reading.bullets, (bullet) => {
                if (
                  note.bulletId === bullet.bulletId &&
                  note.noteType === bullet.noteType &&
                  note.groupId === bullet.groupId &&
                  note.questionId === bullet.questionId
                ) {
                  return {
                    ...bullet,
                    ...objUpd,
                  };
                } else {
                  return bullet;
                }
              }),
            };
          } else {
            return reading;
          }
        }),
      })),
    };
  },

  //[constants.GET_NOTES_DOWNLOAD_ADDRESS_SUCCESS](state, downloadAddress) {
  //  if (undefined !== downloadAddress && null !== downloadAddress) {
  //    state.downloadAddress = downloadAddress;
  //  }
  //},

  [constants.SET_READING_IDX](state, readingIdx) {
    state.readingIdx = readingIdx;
    state.bulletIdx = 0;
    state.noteIdx = 0;
  },

  [constants.SET_BULLET_IDX](state, bulletIdx) {
    state.bulletIdx = bulletIdx;
    state.noteIdx = 0;
  },

  [constants.SET_NOTE_IDX](state, noteIdx) {
    state.noteIdx = noteIdx;
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getNotesDetail({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getNotesDetail(payload);
    commit(constants.GET_NOTE_DETAIL_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  //async publicNotesRft({ commit }, payload) {
  //  const res = await services.publicNotesRft(payload);
  //  commit(constants.GET_NOTE_DETAIL_SUCCESS, res.data.data);
  //},

  async updateNote({ commit }, payload) {
    const { note, objUpd } = payload;
    if ('bullet' === note.noteType) {
      await services.updateBulletNote({
        bulletId: note.bulletId,
        content: objUpd.content,
      });
    } else if ('question' === note.noteType) {
      await services.updateQuestionNote({
        courseId: note.courseId,
        groupId: note.groupId,
        questionId: note.questionId,
        content: objUpd.content,
      });
    }
    commit(constants.UPDATE_NOTE_DETAIL_SUCCESS, payload);
  },

  //async addToFavoriteList({ commit }, payload) {
  //  const { note, objUpd } = payload;
  //  const res = await services.addToFavoriteList({
  //    bulletId: note.bulletId,
  //    toCollect: objUpd.toCollect,
  //  });
  //  if (res.data.data) {
  //    commit(constants.UPDATE_NOTE_DETAIL_SUCCESS, payload);
  //  }
  //},

  //async generateFile({ commit }, payload) {
  //  const params = services.generateFile(payload);
  //  const res = await params;
  //  commit(constants.GET_NOTES_DOWNLOAD_ADDRESS_SUCCESS, res.data.data);
  //  return params;
  //},
};

const getters = {
  noteDetail: (state) => {
    const noteDetail = state.noteDetail;
    return {
      ...noteDetail,
      books: _.map(noteDetail.books, (book) => ({
        ...book,
        readings: _.map(book.readings, (reading, readingIdx) => {
          const readingBullets = _.map(reading.bullets, (bullet) => ({
            bulletId: bullet.bulletId,
            bulletName: bullet.bulletName,
          }));
          const lstBulletUniqByBulletId = _.uniqBy(readingBullets, 'bulletId');
          const objBulletsGroupByBulletId = _.groupBy(reading.bullets, (bullet) => bullet.bulletId);
          return {
            ...reading,
            readingIdx,
            bullets: _.map(lstBulletUniqByBulletId, (bullet, bulletIdx) => {
              let notes = _.map(objBulletsGroupByBulletId[bullet.bulletId], (note) => ({
                ...note,
                courseId: noteDetail.courseId,
                bookId: book.bookId,
                readingId: reading.readingId,
                isNew: bullet.newPath,
                endOfReading: true,
                isLatest: true,
                bulletStatus: false,
                readingIdx,
                bulletIdx,
              }));
              let videoNotes = _.map(
                _.filter(notes, (note) => 'bullet' === note.noteType),
                (note, videoNoteIdx) => ({ ...note, videoNoteIdx })
              );
              let questionNotes = _.map(
                _.filter(notes, (note) => 'question' === note.noteType),
                (note, questionNoteIdx) => ({ ...note, questionNoteIdx })
              );
              notes = _.map([...videoNotes, ...questionNotes], (note, noteIdx) => ({
                ...note,
                noteIdx,
              }));
              videoNotes = _.filter(notes, (note) => 'bullet' === note.noteType);
              questionNotes = _.filter(notes, (note) => 'question' === note.noteType);
              return {
                ...bullet,
                readingIdx,
                bulletIdx,
                notes,
                videoNotes,
                questionNotes,
              };
            }),
          };
        }),
      })),
    };
  },

  noteBookDetail: (state, getters) => {
    const { books, ...noteDetail } = getters.noteDetail;
    return {
      ...noteDetail,
      ...books[0],
    };
  },

  currentReading: (state, getters) => {
    let currentReading;
    if (getters.noteBookDetail.readings && getters.noteBookDetail.readings.length) {
      currentReading = getters.noteBookDetail.readings[state.readingIdx];
    }
    return currentReading ? currentReading : {};
  },

  currentBullet: (state, getters) => {
    let currentBullet;
    if (getters.currentReading.bullets && getters.currentReading.bullets.length) {
      currentBullet = getters.currentReading.bullets[state.bulletIdx];
    }
    return currentBullet ? currentBullet : {};
  },

  currentBulletVideoNotes: (state, getters) => {
    let currentBulletVideoNotes = getters.currentBullet.videoNotes;
    return currentBulletVideoNotes ? currentBulletVideoNotes : [];
  },

  currentBulletQuestionNotes: (state, getters) => {
    let currentBulletQuestionNotes = getters.currentBullet.questionNotes;
    return currentBulletQuestionNotes ? currentBulletQuestionNotes : [];
  },

  currentNote: (state, getters) => {
    let currentNote;
    if (getters.currentBullet.notes && getters.currentBullet.notes.length) {
      currentNote = getters.currentBullet.notes[state.noteIdx];
    }
    return currentNote ? currentNote : {};
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
